import React, { FC } from 'react';

import { Close24 } from '../../icons';
import { IconButton, IconButtonProps } from '../IconButton';


const buttonOffsetBySize: Record<IconButtonProps['size'], number> = {
    extraSmall: 4,
    small: 4,
    medium: 6,
    large: 6,
    extraLarge: 6,
    extraExtraLarge: 6,
};

export interface CloseModalButtonProps extends IconButtonProps {
    absolute?: boolean;
    withBorder?: boolean;
}

export const CloseModalButton: FC<CloseModalButtonProps> = ({
    onClick,
    size = 'medium',
    variant = 'secondary',
    absolute = true,
    withBorder,
    ...props
}) => (
    <IconButton
        data-testid='button-close'
        onClick={onClick}
        isRound
        variant={variant}
        size={size}
        sx={({ spacing }) => ({
            ...withBorder ? {
                border: 1,
                borderColor: 'grayscale.shade80',
            } : {},
            ...absolute ? {
                position: 'absolute',
                top: spacing(buttonOffsetBySize[size]),
                right: spacing(buttonOffsetBySize[size]),
                zIndex: 1,
            } : {},
        })}
        {...props}
    >
        <Close24 />
    </IconButton>
);
